import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { EntFeed } from 'src/app/models/commission/ent-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { CommissionService } from 'src/app/service/commission.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-ent-feed-result',
  templateUrl: './ent-feed-result.component.html',
  styleUrls: ['./ent-feed-result.component.css']
})
export class EntFeedResultComponent implements OnInit {
  feedResultsData: EntFeed[] = [];
  feedResultsDataExcel: EntFeed[] = [];
  feedResultsRepData: EntFeed[] = [];
  rateCodeData: EntFeed[] = [];
  reportingCentersData: EntFeed[] = [];
  columnsData: any;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  ordersTableColumns: TableColumn[];
  ordersTableColumns2: TableColumn[];
  resHeadder: string = 'ENT Feed Results';
  actions: any;
  actionButtons: any;
  buttons: Buttons[] = [];
  entFeedModel = new EntFeed();
  entFeedModel1 = new EntFeed();
  IsmodelShow: boolean = false;
  exportExcelUserData: EntFeed[] = [];
  isAccessDisabled: boolean = false;

  menusFilter: UserManagementModel[] = [];
  isView: boolean = true;
  permissionCheck: any;
  errorMessage: string;
  delcodeid: string;
  addcodeid: string;
  currproclassid: string;
  prevproclassid: string;
  orderdt: Date;

  // showVal1: boolean;
  // showVal2: boolean;
  // showVal3: boolean;
  // showVal4: boolean;
  // showVal5: boolean;
  // showVal6: boolean;
  // showVal7: boolean;
  // showVal8: boolean;
  // showVal9: boolean;
  // showVal10: boolean;

  // showVal11: boolean;
  // showVal12: boolean;
  // showVal13: boolean;
  // showVal14: boolean;
  // showVal15: boolean;
  // showVal16: boolean;
  // showVal17: boolean;
  // showVal18: boolean;
  // showVal19: boolean;
  // showVal20: boolean;


  // public rctr01: string;
  // public rctr02: string;
  // public rctr03: string;
  // public rctr04: string;
  // public rctr05: string;
  // public rctr06: string;
  // public rctr07: string;
  // public rctr08: string;
  // public rctr09: string;
  // public rctr10: string;

  // public rctr11: string;
  // public rctr12: string;
  // public rctr13: string;
  // public rctr14: string;
  // public rctr15: string;
  // public rctr16: string;
  // public rctr17: string;
  // public rctr18: string;
  // public rctr19: string;
  // public rctr20: string;

  // public rc01: string;
  // public rc02: string;
  // public rc03: string;
  // public rc04: string;
  // public rc05: string;
  // public rc06: string;
  // public rc07: string;
  // public rc08: string;
  // public rc09: string;
  // public rc10: string;

  // public rc11: string;
  // public rc12: string;
  // public rc13: string;
  // public rc14: string;
  // public rc15: string;
  // public rc16: string;
  // public rc17: string;
  // public rc18: string;
  // public rc19: string;
  // public rc20: string;

  constructor(private komFeedService: KomFeedService, private commissionService: CommissionService, private router: Router,
    private notificationService: NotificationService, private httpService: HttpClient,
    private exportExcelService: ExportExcelService, private globalService: GlobalService) { }

  ngOnInit(): void {
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('comm-plan');
    if (this.isAccessDisabled)
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
  }

  init() {
    this.getResults();
    this.getResultsExcel();
    this.initializeColumns();
    this.initializeExcelHeaders();
    this.checkPermission();
  }

  getResults() {
    if(this.commissionService.entFeedModel.isEnterprise){
      this.komFeedService.getEnterpriseResults(this.commissionService.entFeedModel).subscribe((data: EntFeed[]) => {
        this.feedResultsData = data;
        console.log(this.feedResultsData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
    }else if(this.commissionService.entFeedModel.isEntRelease){
      this.komFeedService.getEntReleaseResults(this.commissionService.entFeedModel).subscribe((data: EntFeed[]) => {
        this.feedResultsData = data;
        console.log(this.feedResultsData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
    }
   
  }

  getResultsExcel() {
    console.log("getResultsExcel() fired", this.commissionService.entFeedModel);
    this.komFeedService.getEntFeedSerchResultsExcel(this.commissionService.entFeedModel).subscribe((data: EntFeed[]) => {
      this.feedResultsDataExcel = data;
      console.log(this.feedResultsDataExcel);
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  public checkPermission() {
    this.errorMessage = '';
    this.menusFilter = JSON.parse(localStorage.getItem('menulist'));
    console.log(this.menusFilter);
    this.menusFilter = this.menusFilter.filter(val => this._normalizeValue(val.nav_page_name).includes(this._normalizeValue('Feed Adjustments')));
    this.permissionCheck = "y";
    if (this.permissionCheck === "y") {
      this.isAccessDisabled = false;
    } else {
      this.isAccessDisabled = true;
    }
    console.log(this.permissionCheck);
    console.log(this.isAccessDisabled);
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }



  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.commissionService.entFeedModel.isEntRelease?this.columnsExcelData.EntReleaseFeedResults:this.columnsExcelData.EntEnterpriseFeedResults;
        console.log("excel columns:"+this.ordersTableExcelHeaderColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {

    this.exportExcelUserData = JSON.parse(JSON.stringify(this.feedResultsDataExcel));
  
    console.log('export row sample:', this.exportExcelUserData?.[0]);
    console.log('headerTitles:', Object.keys(this.ordersTableExcelHeaderColumns?.[0] || {}));
    console.log('nameToKey preview:', this.ordersTableColumns?.map((c:any)=>({ name:c.name, dataKey:c.dataKey })));
  
    // 1) Get the Excel header titles in the exact order from excelHeaders.json
    const headerTitles: string[] = Object.keys(this.ordersTableExcelHeaderColumns[0]); 
    // e.g. ["ENT Feed ID","Order ID",...,"Status"]
  
    // 2) Build a lookup: column "name" -> "dataKey" from tableColumns.json (current mode: enterprise/release)
    const nameToKey = new Map<string, string>();
    (this.ordersTableColumns || []).forEach((c: any) => {
      if (c?.name && c?.dataKey) nameToKey.set(c.name, c.dataKey);
    });
  
    // 3) Build rows by header order (NOT Object.values)
    this.dataForExcel = this.exportExcelUserData.map((row: any) =>
      headerTitles.map((title: string) => {
        const key = nameToKey.get(title);     // ex: "Status" -> "status"
        return key ? (row?.[key] ?? '') : ''; // if not found, blank
      })
    );
  
    const reportData = {
      title: this.commissionService.entFeedModel.isEntRelease ? 'Enterprise Release Data' : 'Enterprise Data',
      data: this.dataForExcel,
      headers: headerTitles
    };
  
    this.exportExcelService.exportExcel(reportData);
  }
  



  public deleteRowByWipByinfoId(id: number): void {
    if (confirm("Are you sure to delete this Record")) {
      this.komFeedService.deleteRowByWipByinfoId(id).subscribe(
        (response: CustomHttpRespone) => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          this.init();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }
  }

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  actionOnButton(action: any) {
    console.log(action);
    if (action === "Add New" && !this.isAccessDisabled) {
      this.IsmodelShow = false;;
      document.getElementById(action).click();
    } else {
      this.errorMessage = 'Edit Permission has Disabled Please Contact Admin';
    }
  }

   update(row: any, values: any) {
    // console.log(row);
    //console.log(values);
    //console.log(values.value);
  }

  openPopup(row: any) {
    //console.log(row);
    // console.log(row.row.corp);
    // console.log(row.row.ratecd);
   // this.getRateCodeInfo(row.row.corp, row.row.ratecd);
    //this.getReportingCentersInfo(row.row.corp, row.row.ratecd);
    document.getElementById('showratecodeinfo').click();
  }

  close(form: NgForm, id: string) {
    console.log('======', id);
    form.reset();
    document.getElementById(id).click();
  }

  public saveNewRecord(kpiForm: NgForm): void {
    // console.log("======= ", this.feedResultsData[0].wibBuyInfoID);
    // this.komfeedModel.wibBuyInfoID = this.feedResultsData[0].wibBuyInfoID;
    this.entFeedModel.id = this.entFeedModel1.id;
    console.log("======= ", this.entFeedModel);

    this.komFeedService.saveWibByInfoDataENT(this.entFeedModel).subscribe((data: EntFeed) => {
      this.notificationService.sendNotification(NotificationType.SUCCESS, 'Inserted Successfully');
      this.close(kpiForm, 'closeAddKPIButton');
      this.init()
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });

  }

  getEntFeedDataByEntFeedId(id: number) {
    //console.log(status);
    this.komFeedService.getEntFeedDataBySearch(id).subscribe
      ((data: EntFeed[]) => {
        this.feedResultsRepData = data;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getEntFeedDataById(id: any, status: string, rowStatus?: string) {
    console.log("getEntFeedDataById() called");
    console.log(id);
    this.komFeedService.getEntFeedDataByEntFeedId(id).subscribe
      ((data: EntFeed) => {
       // console.log(JSON.stringify(data));
        this.commissionService.editEntFeedModel = data;
        if (rowStatus) {
          this.commissionService.editEntFeedModel.status = rowStatus;
        }

        (this.commissionService.editEntFeedModel as any).actionStatus = status;
        this.router.navigate(['/edit-entFeed']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  
  onAddRecord(entFeed: EntFeed) {
    this.entFeedModel1 = entFeed;
    console.log(this.entFeedModel1.id);
    document.getElementById("Add New").click();
  }


  innerRowAction1(row: any) {
    //console.log(row);
    console.log(row.row.id);
    if (row.value === 'View') {
      console.log("Selected row is: "+row);
      this.orderdt = row.row.wordate;
      this.getEntFeedDataByEntFeedId(row.row.id);
    }
    if (!this.isAccessDisabled) {
      if (row.value === 'Update') {
         console.log(row.row);
         this.openEditPage(row.row, 'Update');
        } else if (row.value === 'Replicate') {
          this.openEditPage(row.row, 'Replicate');
        } else if (row.value === 'Add') {
        console.log("Inside Add");
        this.onAddRecord(row.row);
      }
    } else {
      this.errorMessage = 'Edit Permission has Disabled Please Contact Admin';
    }
  }

  openEditPage(rowData: any, action: string) {
    this.commissionService.entFeedModel.isEntRelease = !!this.commissionService.entFeedModel.isEntRelease;

    // Load full DB row for enterprise updates so partial grid data does not overwrite other columns
    if (action === 'Update' && !this.commissionService.entFeedModel.isEntRelease) {
      this.getEntFeedDataById(rowData.id, action, rowData.status);
      return;
    }

    this.commissionService.editEntFeedModel = { ...rowData };
    (this.commissionService.editEntFeedModel as any).actionStatus = action;
    this.router.navigate(['/edit-entFeed']);
  }
  

  innerRowAction2(row: any) {
    console.log("innerRowAction ....", row);
    console.log("innerRowAction ....", row.value);
    if (row.value === 'Delete') {
      this.deleteRowByWipByinfoId(row.row.wibBuyInfoID);
    }

  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        const isRelease = localStorage.getItem('ent_is_release') === 'Y';
        this.ordersTableColumns = isRelease
          ? this.columnsData.EntReleaseResults
          : this.columnsData.EntFeedResults;
  
        this.ordersTableColumns2 = this.columnsData.EntFeedRepResults;
        //console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'Add',
        dataKey: 'fa fa-plus success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      },
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Replicate',
        dataKey: 'far fa-clone primary f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      }
    ]

    this.actionButtons = [
      // {
      //   name: 'Add New',
      //   class: 'btn btn-success btn-xs'
      // }
    ]
    this.buttons = [

      {
        name: 'Back',
        pagenavigation: 'adjustments-feed'
      }
    ]
  }

}